module.exports = __webpack_public_path__ + "img/app_store.eec84378.svg";